// Paleta categórica validada (dataviz skill): 8 matizes, ordem fixa, nunca ciclar.
// Validado com scripts/validate_palette.js contra a superfície branca do app (#ffffff):
// todos os checks PASS; aqua/amarelo/magenta ficam abaixo de 3:1 de contraste, por isso
// todo uso dessas cores vem sempre acompanhado de rótulo de texto visível (nunca só a cor).
export const CATEGORICAL_ORDER = [
  'blue',
  'orange',
  'aqua',
  'yellow',
  'magenta',
  'green',
  'violet',
  'red',
] as const;

export const CATEGORICAL_PALETTE: Record<(typeof CATEGORICAL_ORDER)[number], string> = {
  blue: '#2a78d6',
  orange: '#eb6834',
  aqua: '#1baf7a',
  yellow: '#eda100',
  magenta: '#e87ba4',
  green: '#008300',
  violet: '#4a3aa7',
  red: '#e34948',
};

export function categoricalColor(index: number): string {
  return CATEGORICAL_PALETTE[CATEGORICAL_ORDER[index % CATEGORICAL_ORDER.length]];
}

// Sequencial: um único matiz (laranja, a cor da marca), claro -> escuro. Usado no mapa de
// calor de horários (magnitude de ocupação), nunca para identidade de série.
export const SEQUENTIAL_BRAND = [
  '#fff6ef',
  '#ffe4cf',
  '#ffca9e',
  '#ff943d',
  '#d0762e',
  '#a55920',
  '#7a3d12',
];

// Status: reservado, nunca reaproveitado como "série 4". Reaproveita os tokens de
// status já usados no restante do app (Badge tone="success|warning|danger").
export const STATUS_COLORS = {
  good: '#059669',
  warning: '#d97706',
  critical: '#dc2626',
};

export const CHART_INK = {
  primary: '#0f172a',
  secondary: '#475569',
  muted: '#94a3b8',
  grid: '#e2e8f0',
  brand: '#ff943d',
};
